import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import "../../Styles/pages/transactions.scss";
import "../../Styles/pages/payments.scss";
import "../../Styles/pages/activities.scss";
import "../../Styles/pages/report.scss"
import "../../Styles/pages/dashboard.scss";
import "../../Styles/pages/subscriptionDetail.scss"
import "../../Styles/pages/customers.scss"
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import PlanActions from "../../Redux/transition/plan/plan.reducer";
import BusinessCustomersActions from '../../Redux/transition/customers/business-customer.reducer';
import { normalizeSegmentsList } from '../Customers/Segments/segmentUtils';
import SelfSignupActions from "../../Redux/transition/self-signup/self-signup.reducer";
import { ActionBar } from './actionBar';
import CustomDataTable from "../../Components/CustomDataTable";
import { FilterMatchMode } from 'primereact/api';
import { Toast } from "primereact/toast";
import { Paginator } from 'primereact/paginator';
import { useDateFormatter } from "../../Components/FormatDateTime";
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

const Uptake = () => {

    const { formatDate } = useDateFormatter();

    const { t } = useTranslation("common");

    const toast = useRef(null);
    const loadingOverlayRef = useRef(null);
    const overlayPanelMoreSubs = useRef(null);
    const treeSelectRef = useRef(null);

    const [state, setState] = useState({
        enterpriseCustomers: null,
        businessId: [],
        businessCustomerReports: {},
        invitesData: [],
        paymentsData: [],
        subscriptionsData: [],
        invitationInfo: {},
        paymentsInfo: {},
        subscriptionInfo: {},
        subscriberInfo: {},
        options: null,
        date: null,
        planReports: [],
        planCharts: [],
        planInvitesData: [],
        planSubscriptionsData: [],
        planPaymentsData: [],
        input: '',
        submitInput: false,
        selectedCustomer: null,
        filteredCustomers: [],
        id: null,
        isAmountTrue: null,
        first: 0,
        size: 15,
        paginate: false,
        flex: false,
        allProductsObject: [],
        page: 0,
        trackAttributionsList: [],
        popupClicked: false,
        stateFilteredDataTotals: {},
        planSelected: null,
        treePlanSelected: null,
        treePlanSelectedKey: '0-0',
        selectedTags: [],
        segmentSelected: null,
        intakeObjects: [],
        tag: [],
        segmentOptions: [],
        planOptions: [],
        plans: [],
        selectedPlan: null
    });

    const [filters, setFilters] = useState({
        'businessCustomer.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'businessCustomer.phoneNo': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    const [filteredData, setFilteredData] = useState([]);
    const [overlayContent, setOverlayContent] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(20);
    const [loadScreen, setLoadScreen] = useState(false);

    //redux state from store
    const defMembership = useSelector((state) => state.defMembership.defMembership)
    const planGroupsGraphedActive = useSelector((state) => state.planGroups.planGroupsGraphedActive);
    const allPlanGroups = useSelector((state) => state.planGroups.planGroups);

    const fetchingSegment = useSelector((state) => state.businessCustomers.fetchingSegment);
    const fetchingTags = useSelector((state) => state.businessCustomers.fetchingTags);
    const invitationUptake = useSelector((state) => state.selfSignups.invitationUptake);
    const { downloadingUptakePdf } = useSelector((state) => state.selfSignups);
    const fetchingInvitationUptake = useSelector((state) => state.selfSignups.fetchingInvitationUptake);
    const segment = useSelector((state) => state.businessCustomers.segmentSuccess);
    const tag = useSelector((state) => state.businessCustomers.tagGroupsGraphed);
    const fetchingPlan = useSelector((state) => state.planGroups.fetchingGraphedActive)


    //redux Dispatch actions
    const dispatch = useDispatch();
    const getMembership = () => dispatch(DefMembershipActions.defMembershipRequest())
    const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)) }, [dispatch])
    const getTagGroups = useCallback((businessId) => dispatch(BusinessCustomersActions.tagGroupGraphedRequest(businessId)), [dispatch]);
    const getSegment = useCallback(
        (businessId) =>
            dispatch(
                BusinessCustomersActions.fetchingSegmentRequest(businessId, {
                    page: 0,
                    size: 1000,
                    sort: "createdDate,desc",
                })
            ),
        [dispatch]
    );
    const getInvitationUptake = useCallback((businessId, planId, query, options) => dispatch(SelfSignupActions.invitationUptakeRequest(businessId, planId, query, options)), [dispatch])
    const downloadUptakePdf = useCallback((businessId, planId, segmentId, tags) => dispatch(SelfSignupActions.downloadUptakePdfRequest(businessId, planId, segmentId, tags)), [dispatch])
    const downloadUptakeCsv = useCallback((businessId, planId, segmentId, tags) => dispatch(SelfSignupActions.downloadUptakeCsvRequest(businessId, planId, segmentId, tags)), [dispatch])
    const getPlan = useCallback(planId => dispatch(PlanActions.planRequest(planId)), [dispatch]);


    const dropdownExportItems = [
        { name: t("payments.download_as_pdf"), code: "PDF", alias: t("payments.pdf_hint") },
        { name: t("payments.download_as_csv"), code: "CSV", alias: t("payments.csv_hint") },
    ]

    const exportItemsTemplate = (option) => {
        const handleExportClick = () => {
            const segmentId = state.segmentSelected || undefined;
            const tags = state.selectedTags?.length > 0 ? state.selectedTags.join("|") : undefined;

            if (option?.code === "PDF") {
                downloadUptakePdf(defMembership.business.id, state.planSelected, segmentId, tags);
            } else {
                downloadUptakeCsv(defMembership.business.id, state.planSelected, segmentId, tags);
            }
        }
        return (
            <section className='flex flex-column mb-1' onClick={() => handleExportClick()}>
                <div className='dropdown-export-temp pt-1'>
                    <p className='m-0 option-name'>{option.name}</p>
                    <i className='pi pi-download' />
                </div>
                <p className='m-0 option-alias'>{option.alias}</p>
            </section>
        )
    }



    const loading = fetchingTags || fetchingSegment || fetchingInvitationUptake || fetchingPlan || loadScreen


    let allPlans;

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
        if (defMembership) {
            getActivePlanGroups(defMembership.business.id);
            getTagGroups(defMembership.business.id)
            getSegment(defMembership.business.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (loading) {
            setOverlayContent(true)
        }
        if (!loading) {
            setOverlayContent(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (defMembership.business.id) {
            setState(state => {
                return { ...state, businessId: defMembership.business.id }
            })
        }

        if (invitationUptake) {
            setState(state => {
                return { ...state, intakeObjects: invitationUptake }
            })
        }
        if (!invitationUptake) {
            setState(state => {
                return { ...state, intakeObjects: [] }
            })
        }

        if (planGroupsGraphedActive) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            allPlans = planGroupsGraphedActive.groups
                .filter(item => item.plans)
                .flatMap(item => item.plans);
        }

        if (segment) {
            const segmentOptions = normalizeSegmentsList(segment);
            setState((state) => ({
                ...state,
                segments: segmentOptions,
                segmentOptions,
            }));
        }
        if (tag) {
            setState(state => {
                return { ...state, tag }
            })
        }
        if (planGroupsGraphedActive) {
            setState(state => {
                return { ...state, plans: allPlans, }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planGroupsGraphedActive, allPlanGroups, invitationUptake])

    useEffect(() => {
        if (state.plans.length > 0 && !state.planSelected) {
            setState(state => ({
                ...state,
                planSelected: state.plans[0].id
            }));
        }
        getPlan(state.planSelected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.plans])


    const subscriptionBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className='text-left mb-2' >
                    {
                        !rowData.subscribed &&
                        <p className="detail-navigation space-beneath red-text sub_text" id="sub_re"
                        >  {t("report.not_subscribed")} </p>
                    }

                    {
                        rowData.subscribed &&
                        <p className="plan-group-text plan_name space-beneath mb-2 ml-2 green-text sub_text text_size" >
                            {t("report.subscribed")}</p>
                    }
                    {
                        rowData.subscribed &&
                        <span className="accepted_status">{rowData?.status}</span>
                    }
                    {
                        rowData.subscribed &&
                        <p className="plan-group-text plan_name space-beneath sub_text mt-3" >
                            {formatDate(rowData.joinedOn)}</p>
                    }
                </div>
                {
                    rowData.customerNum && (rowData.busCustomerName || rowData.customerName) ? <div>
                        <p className="text-left cus-text space-beneath"> {rowData.customerNum}</p>
                        <p className="ref-text text-left space-beneath" id='tierSub'> {rowData.busCustomerName || rowData.customerName}</p>
                    </div>
                        : !rowData.customerNum && (rowData.busCustomerName || rowData.customerName) ?
                            <p className="text-left cus-text space-beneath">
                                {rowData.busCustomerName || rowData.customerName}</p> : null
                }
                {
                    rowData.phoneNo ?
                        <span className="ref-text " id='tierSub' >{rowData.phoneNo} </span> : null
                }
            </div>
        }
    }

    const customerBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className='text-left  mb-2'>
                    {
                        rowData.businessCustomer.name ?
                            <p className="detail-navigation space-beneath no-hover"
                            >  {rowData.businessCustomer.name} </p> : <p></p>
                    }

                    {
                        rowData.businessCustomer.customerNum ?
                            <p className="plan-group-text plan_name customerId space-beneath no-hover-blue" id="sub_ref" >
                                {rowData.businessCustomer.customerNum}</p> : <p></p>
                    }
                </div>

            </div>
        }
    }
    const phoneNoBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className='text-left mb-2'>
                    {
                        rowData.businessCustomer.phoneNo ?
                            <p className="detail-navigation space-beneath no-hover"
                            >  {rowData.businessCustomer.phoneNo} </p> : <p></p>
                    }
                </div>

            </div>
        }
    }
    const invitationBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                <div className='text-left'>
                    {rowData.lastInvitationRoute === "BUSINESS" ? (
                        <div className="flex align-items-center">
                            <span className="route_type">{t("invitation.sms")}</span>
                        </div>
                    ) : rowData.lastInvitationRoute === "SELF" ? (
                        <span className="route_type">{t("invitation.link")}</span>
                    ) : (
                        ""
                    )}
                    {
                        <div className="status_template_invitation mt-2">

                            {rowData.lastInvitationStatus === "ACCEPTED" && <div><span className="accepted_status-uptake">{rowData?.lastInvitationStatus}</span></div>}
                            {rowData.lastInvitationStatus === "ERROR" && <div><span className="error_status">{rowData?.lastInvitationStatus}</span></div>}
                            {rowData.lastInvitationStatus === "PENDING" && <div><span className="pending_status-uptake">{rowData?.lastInvitationStatus}</span></div>}
                            {rowData.lastInvitationStatus === "INCOMPLETE" && <div style={{ margin: "1.5rem 0rem", textAlign: "left", width: "100%" }}>

                            </div>}
                        </div>
                    }

                    {
                        rowData.lastInvitationDate ?
                            <p className="plan-group-text plan_name space-beneath sub_text mt-3" >
                                {formatDate(rowData.lastInvitationDate)}</p> : <p></p>
                    }
                </div>

            </div>
        }
    }

    const segmentBodyTemplate = (rowData) => {
        if (rowData) {
            return <div>
                {rowData.segmentName && <div className='text-left segment-tag-div mb-2' style={{paddingTop:"0.2rem"}}>
                    {
                        <p className="detail-navigation segment-class space-beneath blue-text"
                        >  {rowData.segmentName} </p>
                    }
                </div>}

            </div>
        }
    }
    const tagBodyTemplate = (rowData) => {
        if (rowData) {
            return <div className='flex gap-1'>
                {rowData.tags &&
                    rowData.tags
                        .replace(/[{}]/g, '')
                        .split(',')
                        .map(tag => {
                            return <div className='text-left tag-div-main tag-class mt-1'>
                                {tag.replace(/"/g, '').trim()}</div>
                        })
                }

            </div>
        }
    }

    const filterInput = (options, placeholder) => {
        const value = options.value || "";
        return (
            <div className="clearable-input">
                <InputText
                    value={value}
                    onChange={(e) =>
                        options.filterApplyCallback(e.target.value)
                    }
                    placeholder={placeholder}
                />
                {value && (<i className='pi pi-times cancel_icon'
                    onClick={() =>
                        options.filterApplyCallback("")
                    }
                />
                )}
            </div>
        );
    }


    let columns = [
        {
            field: "businessCustomer.name",
            header: t("common.customer_name"),
            className: "phone_col",
            body: customerBodyTemplate,
            alignHeader: "left",
            filter: true,
            filterElement: (options) => filterInput(options, t("subscriber.search_placeholder")),
            showFilterMenu: false,
        },
        {
            field: "businessCustomer.phoneNo",
            header: t("common.phone_no"),
            className: "phone_col",
            alignHeader: "left",
            body: phoneNoBodyTemplate,
            filter: true,
            filterElement: (options) => filterInput(options, t("invitation.search_phone")),
            showFilterMenu: false,
        },
        {
            field: "LatestInvitation",
            header: "Latest Invitation",
            className: "",
            body: invitationBodyTemplate,
            alignHeader: "left",
        },
        {
            field: "subscription",
            header: t("payments.subscription_status"),
            body: subscriptionBodyTemplate,
            alignHeader: "left",
        },
        {
            field: "SegmentName",
            header: t("business_customers.segment"),
            body: segmentBodyTemplate,
            alignHeader: "left"
        },
        {
            field: "tags",
            header: t("business_customers.tags"),
            body: tagBodyTemplate,
            alignHeader: "left"
        },
    ];

    const transformedTagOptions = useMemo(() => {
        if (!tag?.groups) return [];

        return tag.groups
            .map(group => ({
                label: group.name,
                code: group.id,
                items: group.tags.map(t => ({
                    label: t.name,
                    value: t.id
                }))
            }))
            .filter(group => group.items.length > 0);
    }, [tag]);

    const handlePlanChange = (value) => {
        setState((prevState) => ({
            ...prevState,
            planSelected: value,
            selectedTags: [],
            segmentSelected: null
        }));
        setFirst(0);
    };

    const handleTagsChange = (value) => {
        setState((prevState) => ({
            ...prevState,
            selectedTags: value || []
        }));
        setFirst(0);
    };

    const handleSegmentChange = (value) => {
        setState((prevState) => ({
            ...prevState,
            segmentSelected: value
        }));
        setFirst(0);
    };

    const paginatedData = useMemo(() => {
        const startIndex = first;
        const endIndex = first + rows;
        return state.intakeObjects.slice(startIndex, endIndex);
    }, [state.intakeObjects, first, rows]);

    const loadingFn = () => {
        setLoadScreen(true);
        setTimeout(() => {
            setLoadScreen(false);
        }, 300)
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        loadingFn();
    };

    useEffect(() => {
        if (state.treePlanSelected?.id && state.treePlanSelected.id !== state.planSelected) {
            setState(prev => ({
                ...prev,
                planSelected: state.treePlanSelected.id,
                selectedTags: [],
                segmentSelected: null
            }));
            setFirst(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.treePlanSelected]);

    useEffect(() => {
        if (state.planSelected && state.businessId) {
            let queryString = '';

            if (state.selectedTags && state.selectedTags.length > 0) {
                queryString += `?tags=${state.selectedTags.join('|')}`;
            }

            if (state.segmentSelected) {
                const separator = queryString ? '&' : '?';
                queryString += `${separator}segmentId=${state.segmentSelected}`;
            }

            getInvitationUptake(
                state.businessId,
                state.planSelected,
                queryString
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.planSelected, state.selectedTags, state.segmentSelected]);

    const handleFilter = (e) => {
        setFirst(0);
        setRows(e?.rows)
        setFilters(e.filters)
    }

    const customTemplate = {
        layout: 'RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport',
        RowsPerPageDropdown: () => {
            const dropdownOptions = [
                { label: '20', value: 20 },
                { label: '50', value: 50 },
                { label: '100', value: 100 },
                { label: '200', value: 200 }
            ];
            return (
                <div className="p-d-flex p-ai-center p-mr-3 p-2" >
                    <span className="" style={{ display: "flex", alignSelf: "center" }}>
                        {t("business_customers.item_labels")}{":"}{' '}
                    </span>
                    <Dropdown
                        value={rows}
                        options={dropdownOptions}
                        onChange={(e) => {
                            setFirst(0)
                            setRows(e.value);
                            loadingFn();
                        }}
                        style={{ width: '70px', minWidth: '70px', border: "1px solid #495057" }}
                        panelClassName="custom-dropdown-panel"
                    />
                </div>
            );
        }
    };

    const filterMade = ![null, ""].includes(filters['businessCustomer.phoneNo'].value
        || filters['businessCustomer.name'].value);


    return (
        <div className='payments-screen'>

            <Toast ref={toast} />
            <ActionBar
                planSelected={state.planSelected}
                state={state}
                setState={setState}
                treeSelectRef={treeSelectRef}
                setPlanSelected={handlePlanChange}
                planOptions={state.plans}
                segmentselected={state.segmentSelected}
                setSegmentSelected={handleSegmentChange}
                segmentoptions={state.segmentOptions}
                tagSelected={state.selectedTags}
                setTagselected={handleTagsChange}
                tagOptions={transformedTagOptions}
                loadingFn={loadingFn}
                loadScreen={loadScreen}
                plan={state.treePlanSelected}
                loading={loading}
                downloadingUptakePdf={downloadingUptakePdf}
                exportItemsTemplate={exportItemsTemplate}
                dropdownExportItems={dropdownExportItems}
            />

            <CustomDataTable
                columns={columns}
                loading={loading}
                value={filterMade ? state.intakeObjects : paginatedData}
                filters={filters}
                onFilter={(e) => handleFilter(e)}
                onValueChange={(filtered) => setFilteredData(filtered)}
                rows={rows}
                filterDisplay="row"
            />

            <Paginator
                first={first}
                rows={rows}
                totalRecords={filterMade ? filteredData?.length : state.intakeObjects.length}
                onPageChange={onPageChange}
                template={customTemplate}
                currentPageReportTemplate="{first} - {last} of {totalRecords}"
                className="custom-paginator"
            />
            <OverlayPanel
                showCloseIcon
                className="subsOverlay"
                ref={overlayPanelMoreSubs}
            >
                <div className="recover-overlay-panel">
                    {overlayContent}
                </div>
            </OverlayPanel>

            <OverlayPanel
                ref={loadingOverlayRef}
                dismissable={false}
                closeOnEscape={false}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '10px',
                    minWidth: '150px'
                }}>
                    <ProgressSpinner style={{ width: '15px', height: '10px' }} />
                </div>
            </OverlayPanel>
        </div>
    );
}

export default Uptake;